import React from 'react'
import { Form } from 'react-bootstrap'
import RequieredInputs from '../../../common/RequiredInputs'
import _ from 'lodash'
import SelectCategory from './SelectCategory'
import Select from './Select'
import { BusinessUnitMultiSelect } from '../../../fields'

const FormProductGeneralInfo = ({
  inputs,
  handleChange,
  categories,
  select,
  newProduct,
  fathersArticle,
}) => {
  const isItMandatory = inputs.isArticuloFinal ? <RequieredInputs /> : ''

  // Funcion ordenar, poner los más recientes arriba de todo (ordenador por el id)
  const sortedCategories = _.orderBy(categories, ['nombre'], ['asc'])

  return (
    <div style={{ padding: 0 }}>

      <div style={{ display: 'block' }}>
        <div
          className="form__container"
          style={{ padding: 0, alignItems: 'flex-start', justifyContent: 'flex-start' }}
        >
          <div className='form-field'>
            <Form.Group>
              <Form.Label className='form__labels'>
                Referencia
              </Form.Label>
              <Form.Control
                className='user-input form__input'
                type='text'
                name='referencia'
                value={inputs.referencia}
                onChange={handleChange}
                placeholder='Referencia'
              />
            </Form.Group>
          </div>
          <div className='form-field' style={{ minWidth: '360px' }}>
            <Form.Group size='lg'>
              <Form.Label className='form__labels'>
                Nombre del producto o família/subfamília <RequieredInputs />
              </Form.Label>
              <Form.Control
                className='user-input form__input'
                type='text'
                name='nombre'
                value={inputs.nombre}
                onChange={handleChange}
                placeholder='Nombre del producto o família/subfamília'
              />
              <Form.Check
                id='check-products'
                type='checkbox'
                name='isArticuloFinal'
                value={inputs.isArticuloFinal}
                defaultChecked={inputs.isArticuloFinal}
                onChange={handleChange}
                label={`Definir como producto final`}
              />
            </Form.Group>
          </div>
          <div className='form-field' style={{ minWidth: '360px' }}>
            <Form.Group size='lg'>
              <Form.Label className='form__labels' style={{ opacity: inputs.isArticuloFinal ? undefined : 0.2 }}>
                Descripción {isItMandatory}
              </Form.Label>
              <Form.Control
                className='user-input form__input scroll-wrap'
                style={{ opacity: inputs.isArticuloFinal ? undefined : 0.2, minHeight: '120px' }}
                disabled={!inputs.isArticuloFinal}
                type='textarea'
                as='textarea'
                name='descripcion'
                value={inputs.descripcion}
                onChange={handleChange}
                placeholder='Añadir descripción si se trata de un producto final'
              />
            </Form.Group>
          </div>
          <div className='form-field'>
            <BusinessUnitMultiSelect
              value={inputs.businessUnits || []}
              onChange={(selectedIds) =>
                handleChange({
                  target: {
                    name: 'businessUnits',
                    value: selectedIds,
                  },
                })
              }
              placeholder='Selecciona las unidades de negocio para este producto...'
              required
            />
          </div>
        </div>
      </div>

      <div style={{ display: 'block' }}>
        <div
          className="form__container"
          style={{ padding: 0, verticalAlign: 'top', alignItems: 'flex-start' }}
        >

          <div className='form-field'>
            <SelectCategory
              categories={sortedCategories}
              inputs={inputs}
              handleChange={handleChange}
            />
          </div>

      {
        /* Si es nuevo articulo los selectores de subfamilia se tratan diferente */
        newProduct ? (
          <>
            {/* Selector para las familias */}
            {select
              ? select.map((elemSelect, i) => {
                
                if (elemSelect && elemSelect.key) {
                  elemSelect = { ...elemSelect, key: i, };
                }
                if (elemSelect && elemSelect.index) {
                  elemSelect = { ...elemSelect, index: `select-index-${i}` };
                }
                if (elemSelect && elemSelect.keyIndex) {
                  elemSelect = { ...elemSelect, keyIndex: `select-keyindex-${i}` };
                }

                return (
                  <>
                  <div
                    index={i}
                    key={i}
                    data-key={i}
                    className='form-field'
                  >
                    {elemSelect}
                  </div>
                  </>
                )
                })
              : null}
          </>
        ) : (
          <div className='form-field'>
            <Select
              inputs={inputs}
              handleChange={handleChange}
              editArticle={true}
              articleListOfParent={fathersArticle}
            />
          </div>
        )
      }
          
        </div>
      </div>

      <hr />

    </div>
  )


}

export default FormProductGeneralInfo
